import { RequestArgs, ResponseArgs, AjaxGlobalConfig } from '@autobest-ui/ajax';
import trackDependency from './trackDependency';

/**
 * 获取每个接口的标识
 * @returns {string}
 */
function getLogId() {
  return `${new Date().getTime()}${Math.random() * 100}`;
}

/**
 * 处理错误或者未解析的请求
 * @param response
 * @param requestArgs
 */
function trackDependencyAtInterceptor(response, requestArgs: RequestArgs) {
  trackDependency({
    options: {
      method: requestArgs.method,
      body: requestArgs.requestConfig.body,
      headers: requestArgs.requestConfig.headers
    },
    url: requestArgs.href.replace(requestArgs.baseUrl, ''),
    duration: Date.now() - requestArgs.expendArgs.startTime,
    response
  });
  return Promise.resolve({
    ...response,
    success: false,
    data: null
  });
}

export interface AjaxInterceptorOptions {
  config: AjaxGlobalConfig;
  store: any;
  logger: any;
  setInitAppInfo?: any;
}

let isUseAjaxInterceptor = false;

export default function ajaxInterceptor(Ajax, options: AjaxInterceptorOptions) {
  if (isUseAjaxInterceptor) {
    return;
  }
  isUseAjaxInterceptor = true;
  // 设置全局配置
  Ajax.setGlobalConfig(options.config);

  /**
   * 接口请求前的参数修改
   */
  Ajax.interceptor.request.use((requestArgs: RequestArgs) => {
    requestArgs.requestConfig.headers.logkey = getLogId();
    requestArgs.requestConfig.headers.site = 'APP';

    requestArgs.expendArgs = {
      ...requestArgs.expendArgs,
      startTime: Date.now()
    };

    return requestArgs;
  });

  /**
   * 普通模式的处理
   */
  Ajax.interceptor.response.use(
    (response: ResponseArgs, requestArgs: RequestArgs) => {
      if (requestArgs.responseType === 'json') {
        if (response.code === 200) {
          response.success = true;
          return response;
        }
      }
      return response;
    }
  );

  /**
   * 处理错误或者未解析的请求
   */
  Ajax.interceptor.response.use(
    async (response: ResponseArgs, requestArgs: RequestArgs) => {
      if (response.success) {
        return response;
      }
      return trackDependencyAtInterceptor(response, requestArgs);
    },
    trackDependencyAtInterceptor
  );
}
